import React, { Component } from 'react';
import { ClockIcon, AlertCircleIcon, TrendingUpIcon, NavigationIcon, PlaneIcon } from 'lucide-react';
interface PickupRecommendationProps {
  flightType: 'departure' | 'arrival';
  flightTime: Date;
  recommendedPickupTime: Date;
  onAdjust: () => void;
}
export const PickupRecommendation: React.FC<PickupRecommendationProps> = ({
  flightType,
  flightTime,
  recommendedPickupTime,
  onAdjust
}) => {
  const factors = [{
    icon: TrendingUpIcon,
    label: 'Causeway congestion',
    value: '75–90 min',
    status: 'high'
  }, {
    icon: NavigationIcon,
    label: 'Travel time',
    value: '40 min',
    status: 'normal'
  }, {
    icon: PlaneIcon,
    label: 'Airport buffer',
    value: '2 hours',
    status: 'normal'
  }];
  return <div className="bg-card border border-primary rounded-lg p-4" data-id="element-104">
      <div className="flex items-center justify-between mb-4" data-id="element-105">
        <div className="flex items-center" data-id="element-106">
          <ClockIcon size={18} className="text-primary mr-2" data-id="element-107" />
          <h3 className="font-medium" data-id="element-108">Recommended Pickup</h3>
        </div>
        <button className="text-primary text-sm font-medium" onClick={onAdjust} data-id="element-109">
          Adjust
        </button>
      </div>
      <div className="bg-primary bg-opacity-10 border border-primary border-opacity-30 rounded-lg p-4 mb-4" data-id="element-110">
        <p className="text-2xl font-bold text-primary" data-id="element-111">
          {recommendedPickupTime.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit'
        })}
        </p>
        <p className="text-sm text-white text-opacity-70 mt-1" data-id="element-112">
          {recommendedPickupTime.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric'
        })}
        </p>
      </div>
      <div className="space-y-2 mb-4" data-id="element-113">
        <p className="text-sm text-white text-opacity-70 font-medium" data-id="element-114">
          Based on:
        </p>
        {factors.map((factor, index) => {
        const IconComponent = factor.icon;
        return <div key={index} className="flex items-center text-sm" data-id="element-115">
              <IconComponent size={14} className="text-primary mr-2" data-id="element-116" />
              <span className="text-white text-opacity-70" data-id="element-117">{factor.label}</span>
              <span className="ml-auto font-medium" data-id="element-118">{factor.value}</span>
            </div>;
      })}
      </div>
      <div className="bg-background rounded-lg p-3 flex items-start" data-id="element-119">
        <AlertCircleIcon size={16} className="text-primary mr-2 mt-0.5 flex-shrink-0" data-id="element-120" />
        <p className="text-xs text-white text-opacity-70" data-id="element-121">
          {flightType === 'departure' ? 'This timing ensures you arrive 2 hours before departure, accounting for current border traffic.' : 'Your driver will be ready when you land. Border clearance typically takes 45-60 minutes.'}
        </p>
      </div>
    </div>;
};